import React, { Component } from 'react';
import PropTypes from "prop-types";

const noop = () => {
	// no operation (do nothing real quick)
};

class FixRequiredSelect extends Component {
	state = {
		value: this.props.value || "",
	};

	selectRef = null;
	setSelectRef = ref => {
		this.selectRef = ref;
	};

	onChange = (value, actionMeta) => {
		this.props.onChange(value, actionMeta);
		this.setState({ value });
	};

	getValue = () => {
		if (this.props.value != undefined) return this.props.value;
		return this.state.value || "";
	};

	render() {
		const { SelectComponent, required, ...props } = this.props;
		const { isLoading, isDisabled } = this.props;
		const enableRequired = !isDisabled;

		return (
			<div className="pda-required-select-wrap">
				<SelectComponent
					{...props}
					ref={this.setSelectRef}
					onChange={this.onChange}
				/>
				{enableRequired && (
					<input
                        className="pda_required_roles"
						tabIndex={-1}
						autoComplete="off"
						value={this.getValue()}
						onChange={noop}
						onFocus={() => this.selectRef.focus()}
						required={required}
					/>
				)}
			</div>
		);
	}
}

FixRequiredSelect.defaultProps = {
	onChange: noop,
};

FixRequiredSelect.protoTypes = {
	// react-select component class (e.g. Select, Creatable, Async)
	selectComponent: PropTypes.func.isRequired,
	onChange: PropTypes.func,
	required: PropTypes.bool,
};

export default FixRequiredSelect;
